module.exports = __webpack_public_path__ + "img/loby-clinics-hospitals.a07c6697.jpg";